import { AppConstant } from "@/const";
import { GenderTypeEnum } from "@/models";
import dayjs from "dayjs";

/**
 * Format number
 *
 * @param {number} number - The number to format
 * @param {number} [maximumFractionDigits = 3] -The length of decimal
 * @param {string} [fallbackLabel = AppConstant.NOT_HAVE_VALUE_LABEL] - Default string will returned when number is the empty string
 * @param {object} [localeOption = {}] - To customized method toLocaleString
 * @param {number} [minimumFractionDigits = 0] - The min length of decimal
 *
 * @return {string} The value of format number
 *
 */
export const formatNumber = (
  number: number | string,
  maximumFractionDigits = 3,
  fallbackLabel = AppConstant.NOT_HAVE_VALUE_LABEL,
  localeOption = {},
  minimumFractionDigits = 0,
) => {
  try {
    if (!number && number !== 0) return fallbackLabel;
    const num = Number(number);
    return num.toLocaleString("vi-VN", {
      maximumFractionDigits,
      minimumFractionDigits,
      ...localeOption,
    });
  } catch (error) {
    return number;
  }
};

/**
 * Check format email
 *
 * @param {string} email  - email
 *
 * @returns {boolean}  Return true if email is correct format, false remaining case
 */
export const checkEmailFormat = (email: string): boolean => {
  const regexEmail =
    /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (email.length && !regexEmail.test(email)) return false;
  else return true;
};

export const checkUrlFormat = (value: string): boolean => {
  const regex = /^(?:[-A-Za-z0-9]+\.)+[A-Za-z]{2,6}$/;

  return regex.test(value);
};

export const formatBytes = (bytes?: number, decimals = 2) => {
  if (!bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const GenderFormatter = (value: GenderTypeEnum) => {
  const formattedGender =
    value === GenderTypeEnum.Girl
      ? "Nữ"
      : value === GenderTypeEnum.Boy
        ? "Nam"
        : "";
  return formattedGender;
};

// AppDateTimePicker
export const formatUnixToDate = (unixData: number | undefined) => {
  if (unixData) {
    return dayjs.unix(unixData);
  } else {
    return null;
  }
};
export const formatDateToUnix = (dateData: Date | undefined) => {
  if (dateData) {
    return dayjs(dateData).unix();
  } else {
    return null;
  }
};

export function formatUnixToDisplay({
  unixTimestamp,
  format = AppConstant.DATE_FORMAT,
}: {
  unixTimestamp: number | undefined;
  format: string;
}) {
  if (unixTimestamp) {
    // Kiểm tra nếu timestamp là mili giây, chuyển đổi về giây
    const adjustedTimestamp =
      unixTimestamp.toString().length > 10
        ? unixTimestamp / 1000
        : unixTimestamp;
    const dateObj = dayjs.unix(adjustedTimestamp);
    return dateObj.format(format);
  } else {
    return null;
  }
}
// AppDateTimePicker
export const formatDateOnly = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
